@if(ui.spinnerVisible()) {
<div class="jenz-overlay-spinner">
  <svg
    overflow="visible"
    width="38"
    height="51"
    viewBox="0 0 38 51"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      class="line-group-up"
      d="M31.1153 31.7374L17.4627 45.3782C17.1918 45.6491 17.1918 46.085 17.4627 46.3559C17.5923 46.4855 17.769 46.5562 17.9457 46.5562C18.1224 46.5562 18.2991 46.4973 18.4286 46.3559L32.0695 32.7151C32.3404 32.4442 32.3404 32.0083 32.0695 31.7374C31.8103 31.4664 31.3745 31.4664 31.1153 31.7374Z"
      fill="#F3922B"
    />
    <path
      class="line-group-down"
      d="M31.1273 26.5306L12.4212 45.2367C12.1503 45.5076 12.1503 45.9435 12.4212 46.2026C12.5508 46.344 12.7275 46.4029 12.9042 46.4029C13.0809 46.4029 13.2576 46.344 13.3871 46.2026L32.0932 27.4966C32.3642 27.2256 32.3642 26.7898 32.0932 26.5188C31.8223 26.2597 31.3982 26.2597 31.1273 26.5306Z"
      fill="#E7267A"
    />
    <path
      class="line-group-up"
      d="M18.146 35.2828C17.8751 35.0119 17.4392 35.0119 17.1801 35.2828L8.42781 44.0469C8.15688 44.3178 8.15688 44.7536 8.42781 45.0246C8.55738 45.1541 8.73408 45.2248 8.91077 45.2248C9.08747 45.2248 9.26417 45.1541 9.39374 45.0246L18.1342 36.2723C18.417 36.0014 18.417 35.5537 18.146 35.2828Z"
      fill="#E52521"
    />
    <path
      class="line-group-up"
      d="M31.1273 21.3478L20.8201 31.655C20.5492 31.9259 20.5492 32.3617 20.8201 32.6327C20.9497 32.7623 21.1264 32.8329 21.3031 32.8329C21.4798 32.8329 21.6565 32.7623 21.7979 32.6327L32.0933 22.3255C32.3642 22.0546 32.3642 21.6187 32.0933 21.3478C31.8223 21.0651 31.3983 21.0651 31.1273 21.3478Z"
      fill="#E52521"
    />
    <path
      class="line-group-down"
      d="M13.599 34.6351C13.3398 34.3642 12.904 34.3642 12.6213 34.6351L5.17654 42.0798C4.91739 42.3508 4.91739 42.7866 5.17654 43.0575C5.30612 43.1871 5.48281 43.2578 5.67129 43.2578C5.84798 43.2578 6.02468 43.1989 6.15426 43.0575L13.599 35.6128C13.8699 35.3419 13.8699 34.906 13.599 34.6351Z"
      fill="#998675"
    />
    <path
      class="line-group-down"
      d="M31.1272 16.1529L20.8436 26.4365C20.5726 26.7075 20.5726 27.1433 20.8436 27.4143C20.9732 27.5438 21.1499 27.6145 21.3265 27.6145C21.5032 27.6145 21.6799 27.5438 21.8095 27.4143L32.0932 17.1306C32.3641 16.8597 32.3641 16.4356 32.0932 16.1529C31.8222 15.882 31.3981 15.882 31.1272 16.1529Z"
      fill="#C7B29A"
    />
    <path
      class="line-group-up"
      d="M31.1272 10.9581L20.8436 21.2417C20.5726 21.5127 20.5726 21.9485 20.8436 22.2077C20.9732 22.3373 21.1499 22.4079 21.3265 22.4079C21.5032 22.4079 21.6799 22.3373 21.8095 22.2077L32.0932 11.924C32.3641 11.6531 32.3641 11.2173 32.0932 10.9463C31.8222 10.6872 31.3981 10.6872 31.1272 10.9581Z"
      fill="#746458"
    />
    <path
      class="line-group-up"
      d="M11.2315 31.8314C10.9606 31.5604 10.5247 31.5604 10.2538 31.8314L2.69124 39.3939C2.4203 39.6648 2.4203 40.1007 2.69124 40.3598C2.82081 40.4894 3.00929 40.5601 3.1742 40.5601C3.3509 40.5601 3.52759 40.5012 3.65717 40.3598L11.2197 32.7973C11.4906 32.5382 11.4906 32.0905 11.2315 31.8314Z"
      fill="#746458"
    />
    <path
      class="line-group-down"
      d="M6.04835 31.8199C5.77742 31.549 5.35336 31.549 5.08242 31.8199L0.912428 35.9899C0.641496 36.2608 0.641496 36.6967 0.912428 36.9676C1.042 37.0972 1.2187 37.1679 1.40717 37.1679C1.58387 37.1679 1.76056 37.0972 1.89014 36.9676L6.06013 32.7976C6.31929 32.5267 6.31928 32.0908 6.04835 31.8199Z"
      fill="#105370"
    />
    <path
      class="line-group-down"
      d="M20.8318 17.0246C20.9614 17.1542 21.1381 17.2249 21.3148 17.2249C21.4915 17.2249 21.6682 17.1542 21.7978 17.0246L32.0814 6.74097C32.3523 6.47004 32.3523 6.03419 32.0814 5.76326C31.8105 5.49233 31.3746 5.49233 31.1037 5.76326L20.8201 16.0469C20.5727 16.3178 20.5727 16.7537 20.8318 17.0246Z"
      fill="#105370"
    />
    <path
      class="line-group-up"
      d="M18.4994 14.1738C18.629 14.3034 18.8056 14.3741 18.9823 14.3741C19.159 14.3741 19.3357 14.3034 19.4653 14.1738L28.8772 4.7619C29.1482 4.49097 29.1482 4.05512 28.8772 3.79597C28.6063 3.52504 28.1705 3.52504 27.8995 3.79597L18.4876 13.2079C18.2284 13.4671 18.2284 13.9029 18.4994 14.1738Z"
      fill="#0D71B9"
    />
    <path
      class="line-group-down"
      d="M13.3045 14.1738C13.4341 14.3034 13.6108 14.3741 13.7993 14.3741C13.976 14.3741 14.1527 14.3034 14.2822 14.1738L23.6942 4.7619C23.9651 4.49097 23.9651 4.05512 23.6942 3.79597C23.435 3.52504 22.9992 3.52504 22.7165 3.79597L13.3045 13.2079C13.0336 13.4671 13.0336 13.9029 13.3045 14.1738Z"
      fill="#2DABE3"
    />
    <path
      class="line-group-up"
      d="M11.9735 11.0051C12.1502 11.0051 12.3151 10.9344 12.4565 10.8049L18.4994 4.7619C18.7704 4.49097 18.7704 4.05512 18.4994 3.79597C18.2285 3.52504 17.7927 3.52504 17.5217 3.79597L11.4906 9.83893C11.2196 10.1099 11.2196 10.5339 11.4906 10.8049C11.6201 10.9462 11.7968 11.0051 11.9735 11.0051Z"
      fill="#8BCDCE"
    />
    <path
      class="line-group-down"
      d="M11.9736 5.82207C12.1503 5.82207 12.3152 5.75139 12.4565 5.62182L13.3165 4.7619C13.5874 4.49097 13.5874 4.05512 13.3165 3.79597C13.0455 3.52504 12.6097 3.52504 12.3388 3.79597L11.4788 4.64411C11.2079 4.91504 11.2079 5.35089 11.4788 5.62182C11.6202 5.75139 11.7969 5.82207 11.9736 5.82207Z"
      fill="#6FC7DA"
    />
    <path
      class="line-group-down"
      d="M15.5664 2.2293C15.743 2.2293 15.908 2.15862 16.0493 2.02905L16.9092 1.16913C17.1802 0.898198 17.1802 0.462351 16.9092 0.203199C16.6383 -0.067733 16.2025 -0.067733 15.9315 0.203199L15.0716 1.05133C14.8007 1.32227 14.8007 1.75811 15.0716 2.02905C15.213 2.15862 15.3779 2.2293 15.5664 2.2293Z"
      fill="#6FC7DA"
    />
    <path
      class="line-group-down"
      d="M10.8898 17.7432C11.0665 17.7432 11.2314 17.6725 11.3728 17.543L12.2327 16.683C12.5036 16.4121 12.5036 15.9763 12.2327 15.7171C11.9618 15.4462 11.5259 15.4462 11.255 15.7171L10.3951 16.5652C10.1242 16.8362 10.1242 17.272 10.3951 17.543C10.5364 17.6725 10.7131 17.7432 10.8898 17.7432Z"
      fill="#2DABE3"
    />
    <path
      class="line-group-down"
      d="M33.1769 26.0713C33.3536 26.0713 33.5186 26.0007 33.6599 25.8711L34.5198 25.0112C34.7908 24.7402 34.7908 24.3044 34.5198 24.0452C34.2489 23.7743 33.813 23.7743 33.5421 24.0452L32.6822 24.8934C32.4113 25.1643 32.4113 25.6002 32.6822 25.8711C32.8236 26.0124 33.0002 26.0713 33.1769 26.0713Z"
      fill="#E7267A"
    />
    <path
      class="line-group-down"
      d="M35.7448 23.5035C35.9215 23.5035 36.0864 23.4328 36.2278 23.3032L37.0877 22.4433C37.3586 22.1724 37.3586 21.7365 37.0877 21.4774C36.8168 21.2064 36.3809 21.2064 36.11 21.4774L35.2501 22.3255C34.9791 22.5964 34.9791 23.0323 35.2501 23.3032C35.3914 23.4328 35.5681 23.5035 35.7448 23.5035Z"
      fill="#E7267A"
    />
    <path
      class="line-group-down"
      d="M17.8635 31.7608C18.0402 31.7608 18.2051 31.6901 18.3464 31.5605L19.2064 30.7006C19.4773 30.4297 19.4773 29.9938 19.2064 29.7347C18.9354 29.4638 18.4996 29.4638 18.2286 29.7347L17.3687 30.5828C17.0978 30.8538 17.0978 31.2896 17.3687 31.5605C17.5101 31.7019 17.6868 31.7608 17.8635 31.7608Z"
      fill="#C7B29A"
    />
    <path
      class="line-group-down"
      d="M8.32173 50.9737C8.49842 50.9737 8.66334 50.903 8.80469 50.7735L11.0428 48.5353C11.3138 48.2644 11.3138 47.8286 11.0428 47.5694C10.7719 47.2985 10.336 47.2985 10.0651 47.5694L7.82698 49.7958C7.55605 50.0667 7.55605 50.5025 7.82698 50.7735C7.96833 50.903 8.14503 50.9737 8.32173 50.9737Z"
      fill="#E7267A"
    />
    <path
      class="line-group-down"
      d="M26.6039 43.152C26.7806 43.152 26.9456 43.0813 27.0869 42.9517L29.325 40.7136C29.596 40.4426 29.596 40.0068 29.325 39.7476C29.0541 39.4767 28.6183 39.4767 28.3473 39.7476L26.1092 41.974C25.8383 42.2449 25.8383 42.6808 26.1092 42.9517C26.2506 43.0813 26.4273 43.152 26.6039 43.152Z"
      fill="#F7AB5E"
    />
    <path
      class="line-group-down"
      d="M31.3156 38.4398C31.4923 38.4398 31.6572 38.3691 31.7986 38.2395L34.0367 36.0014C34.3077 35.7305 34.3077 35.2946 34.0367 35.0355C33.7658 34.7645 33.3299 34.7645 33.059 35.0355L30.8209 37.2618C30.5499 37.5328 30.5499 37.9686 30.8209 38.2395C30.9622 38.3691 31.1389 38.4398 31.3156 38.4398Z"
      fill="#F7AB5E"
    />
    <path
      class="line-group-up"
      d="M33.966 30.6183C34.1427 30.6183 34.3076 30.5476 34.449 30.418L36.6871 28.1799C36.958 27.9089 36.958 27.4731 36.6871 27.2139C36.4162 26.943 35.9803 26.943 35.7094 27.2139L33.4713 29.4403C33.2003 29.7112 33.2003 30.1471 33.4713 30.418C33.6126 30.5476 33.7893 30.6183 33.966 30.6183Z"
      fill="#F3922B"
    />
    <path
      class="line-group-down"
      d="M3.2331 45.8492C3.40979 45.8492 3.57471 45.7785 3.71606 45.6489L4.57598 44.789C4.84691 44.5181 4.84691 44.0822 4.57598 43.8231C4.30505 43.5521 3.8692 43.5521 3.59827 43.8231L2.73836 44.6712C2.46742 44.9421 2.46742 45.378 2.73836 45.6489C2.87971 45.7903 3.0564 45.8492 3.2331 45.8492Z"
      fill="#998675"
    />
  </svg>
</div>
}
